import { render, staticRenderFns } from "./GExamCreateBaseSettingTitleLanguage.vue?vue&type=template&id=6598265b&scoped=true&"
import script from "./GExamCreateBaseSettingTitleLanguage.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateBaseSettingTitleLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./GExamCreateBaseSettingTitleLanguage.vue?vue&type=style&index=0&id=6598265b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6598265b",
  null
  
)

export default component.exports